import { Grid } from "@mui/material";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import ListProposals from "modules/proposals/ListProposals";
import ProposalMetricCards from "./ProposalMetricCards";

export default function ProposalsListPage() {
  return (
    <DashboardPage>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ProposalMetricCards />
        </Grid>

        <Grid item xs={12}>
          <ListProposals />
        </Grid>
      </Grid>
    </DashboardPage>
  );
}
